module.exports = __webpack_public_path__ + "img/pdf.e33f61a.png";